<script>
import Layout from '@layouts/default'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'

/**
 * Login component
 */
export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      user: '',
      password: '',
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    }
  },
  mounted() {
    document.body.style.paddingBottom = '0'
  },
  computed: {
    placeholders() {
      return process.env.NODE_ENV === 'production'
        ? {}
        : {
            user: 'Use "admin" to log in with the mock API',
            password: 'Use "password" to log in with the mock API',
          }
    },
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = null
      this.logIn({
        usuario: this.user,
        password: this.password,
      })
        .then((token) => {
          this.tryingToLogIn = false
          this.isAuthError = false
          // Redirect to the originally requested page, or to the home page
          this.$router.push(
            this.$route.query.redirectFrom || { name: 'Dashboard' }
          )
        })
        .catch((error) => {
          this.tryingToLogIn = false
          this.authError = 'Usuário ou Senha inválidos!'
          this.isAuthError = true

          setTimeout(() => {
            this.isAuthError = false
          }, 3000)
        })
    },
  },
}
</script>

<template>
  <div id="login" class="content-login">
    <div id="background">
      <img
        src="@assets/images/background-login.png"
        alt="WebReceita receituário agronômico"
      />
    </div>

    <main class="main-login">
      <div class="container-login">
        <section>
          <div class="logo">
            <img src="@assets/images/logo_dark.png" alt="webreceita" />
          </div>

          <h2>Gestão</h2>
          <p>Seja bem-vindo!</p>

          <b-alert v-model="isAuthError" variant="danger">{{
            authError
          }}</b-alert>

          <form @submit.prevent="tryToLogIn">
            <div class="input-group">
              <input
                v-model="user"
                class="input"
                type="text"
                id="name"
                required
              />
              <label for="name">Nome</label>
            </div>

            <div class="input-group">
              <input
                v-model="password"
                class="input"
                type="password"
                id="passwrord"
                required
              />
              <label for="password">Senha</label>
            </div>
            <button type="submit">
              <span v-if="!tryingToLogIn">Entrar</span>
              <b-spinner v-else small></b-spinner>
            </button>
          </form>
        </section>
      </div>
    </main>
  </div>
</template>

<style scoped src="./style.css"/>